import { fixLineBreaks } from 'components/MCTextEditor/dataFormat/parse/utils/fixLineBreaks'

import {
  ISlice,
  IDeleteOperation,
  IInsertOperation,
  ISelectOperaion,
  ISliceOperation,
} from '../constants'

export const createDelete = (start: number, length: number, source?: string): IDeleteOperation => {
  return { type: 'delete' as const, start, length, source }
}

export const createInsert = (
  start: number,
  text: string,
  slices?: ISlice[],
  source?: string,
): IInsertOperation => {
  text = fixLineBreaks(text)
  return { type: 'insert' as const, start, text, slices, source }
}

export const createSelect = (start: number, end?: number): ISelectOperaion => {
  end = typeof end === 'undefined' ? start : end
  if (start > end) {
    start = end
  }
  return { type: 'select' as const, start, length: end - start }
}

export const createSetSliceData = (slice: ISlice, data: unknown): ISliceOperation => {
  return { type: 'slice-data' as const, slice, data }
}

export const createInsertSlice = (slice: ISlice): ISliceOperation => {
  return { type: 'slice-insert' as const, slice }
}

export const createDeleteSlice = (slice: ISlice): ISliceOperation => {
  return { type: 'slice-delete' as const, slice }
}

export const createRender = () => {
  return { type: 'render' as const }
}
